import { Portal, PortalHost } from '@gorhom/portal';
import React from 'react';

export const HasNestedScrollViewPortalProvider = React.createContext<boolean>(false);

const nestedScrollViewPortalName = 'nested-scroll-view-portal';

export const NestedScrollViewPortalHostContainer: React.FC<{ children: any }> = (props) => (
    <HasNestedScrollViewPortalProvider.Provider value={true}>
        {props.children}
        <PortalHost name={nestedScrollViewPortalName} />
    </HasNestedScrollViewPortalProvider.Provider>
);

export const useHasNestedScrollViewPortal = () => React.useContext(HasNestedScrollViewPortalProvider);

export const MaybeRenderNestedScrollViewPortal: React.FC<{ children: any }> = ({ children }) => {
    const hasPortal = useHasNestedScrollViewPortal();
    return hasPortal ? (
        <Portal hostName={nestedScrollViewPortalName}>
            <HasNestedScrollViewPortalProvider.Provider value={false}>
                {children}
            </HasNestedScrollViewPortalProvider.Provider>
        </Portal>
    ) : (
        children
    );
};

export const useAssertHasNestedScrollViewPortal = () => {
    if (!useHasNestedScrollViewPortal()) {
        throw new Error('useAssertHasNestedScrollViewPortal must be used within a NestedScrollViewPortalHostContainer');
    }
};
